const STORAGE_KEY = "qr_tools_history_v1";
const MAX_ITEMS = 100;

export function readHistory() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function addHistoryItem(item) {
  const list = readHistory();
  const enriched = {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    createdAt: new Date().toISOString(),
    ...item,
  };
  const next = [enriched, ...list].slice(0, MAX_ITEMS);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  return enriched;
}

export function removeHistoryItem(id) {
  const list = readHistory().filter((i) => i.id !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  return list;
}

export function clearHistory() {
  localStorage.removeItem(STORAGE_KEY);
}
